import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classname from 'classnames';
import TruncateText from './TruncateText';
import './scrollableText.less';
/**
 * a generic component for holding text that may overflow
 * text is truncated with the option to display in a scrollable container.
 * @class ScrollableText
 * @extends Component
 */
class ScrollableText extends Component{
    constructor(props){
        super(props);

        this.state = {
            scrolling: this.props.scrolling,
            text: this.props.children
        };

        this.toggleScrolling = this.toggleScrolling.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(this.state.text !== nextProps.children){
            this.setState({scrolling: false, text:nextProps.children});
        }
    }
    toggleScrolling(){
        const enabled = this.state.scrolling;
        this.setState({scrolling:!enabled});
    }
    renderToggleMore(){
        if(!this.state.scrolling){
            return this.renderToggle('(More)');
        }
    }
    renderToggleLess(){
        if(this.state.scrolling){
            return this.renderToggle('(Less)');
        }
    }
    renderToggle(text){
        return (<a onClick={this.toggleScrolling} className={classname('clickable','scroll-toggle')}>{text}</a>);
    }
    renderText(){
        let ret = this.props.children;
        if(!this.state.scrolling){
            ret = (<TruncateText line={this.props.line} text={this.props.children} textTruncateChild={this.renderToggleMore()}/>);
        }
        return ret;
    }

    render(){
        const className=classname('scrollable-text', { scrolling:this.state.scrolling });
        return (<div className={'scroll-container'}>
                    <div className={className}>
                        {this.renderText()}
                    </div>
                    {this.renderToggleLess()}
                </div>
            );
    }
}

ScrollableText.defaultProps = {
    scrolling:false,
    line:4
};
ScrollableText.propTypes = {
    scrolling: PropTypes.bool,
    line:PropTypes.number,
    children: PropTypes.string
};
export default ScrollableText;



// WEBPACK FOOTER //
// ./src/react/views/generic/ScrollableText.jsx